import { styled } from '@material-ui/core/styles';
import { Form } from '@rocketseat/unform';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export const Container = styled(Box)({
  width: '100vw',
  minHeight: '100vh',
  display: 'grid',
  gridTemplateColumns: '2fr 1fr',
  '@media screen and (max-width: 900px)': {
    gridTemplateColumns: '1fr',
  },
  '& input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active': {
    transition: 'background-color 5000s ease-in-out 0s',
  },
  '& input:-webkit-autofill': {
    WebkitTextFillColor: '#ffffffdd !important',
  },
});

export const MarketingSide = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '60px 48px',
  paddingTop: '100px',
  background: 'linear-gradient(160deg, #1E2141 0%, #2C325C 50%, #1E2141 100%)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    right: '-30%',
    width: '500px',
    height: '500px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255, 238, 88, 0.04) 0%, transparent 70%)',
  },
  '@media screen and (max-width: 900px)': {
    display: 'none',
  },
});

export const FormSide = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '40px 32px',
  '@media screen and (max-width: 480px)': {
    padding: '32px 20px',
  },
});

export const FormCard = styled(Box)({
  width: '100%',
  maxWidth: '380px',
});

export const FormLogin = styled(Form)({
  width: '100%',
  '& .input-wrapper': {
    position: 'relative',
    marginBottom: '16px',
  },
  '& .input-wrapper label': {
    display: 'block',
    fontSize: '13px',
    fontWeight: 600,
    color: '#ffffffaa',
    marginBottom: '8px',
  },
  '& .input-field': {
    display: 'flex',
    alignItems: 'center',
    background: '#1E2141',
    borderRadius: '10px',
    border: '1px solid #ffffff10',
    transition: 'border-color 0.2s ease',
    padding: '0 14px',
  },
  '& .input-field.focus': {
    borderColor: '#ffee58',
  },
  '& .input-field svg': {
    color: '#ffffff44',
    fontSize: '20px',
    flexShrink: 0,
    transition: 'color 0.2s ease',
  },
  '& .input-field.focus svg': {
    color: '#ffee58',
  },
  '& .input-field input': {
    flex: 1,
    border: 'none',
    outline: 'none',
    background: 'none',
    padding: '12px 12px',
    fontSize: '15px',
    color: '#ffffffdd',
  },
  '& .input-field input::placeholder': {
    color: '#ffffff44',
  },
  '& .input-wrapper span': {
    display: 'block',
    color: '#ff6b6b',
    fontSize: '12px',
    marginTop: '6px',
    paddingLeft: '2px',
  },
  '& .submitButton': {
    width: '100%',
    marginTop: '8px',
    borderRadius: '10px',
    padding: '12px',
    fontWeight: 700,
    fontSize: '15px',
    color: '#1E2141',
    textTransform: 'none',
  },
});

export const useStyles = makeStyles({
  logo: {
    display: 'block',
    width: '180px',
    marginBottom: '28px',
  },
  welcomeText: {
    fontSize: '14px',
    color: '#ffffff77',
    marginBottom: '24px',
  },
  footer: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
    color: '#ffffff88',
    '& a': {
      color: '#ffee58',
      fontWeight: 600,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  marketingLogo: {
    display: 'block',
    width: '220px',
    marginBottom: '32px',
  },
  heroImageWrapper: {
    width: '100%',
    maxWidth: '620px',
    marginBottom: '36px',
    overflow: 'hidden',
    borderRadius: '8px',
    filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.4))',
  },
  heroImage: {
    width: '100%',
    display: 'block',
  },
  heroSubtitle: {
    fontSize: '15px',
    color: '#ffffffaa',
    textAlign: 'center',
    maxWidth: '420px',
    lineHeight: 1.6,
    marginBottom: '32px',
  },
  featureList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    width: '100%',
    maxWidth: '380px',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: '#ffffffcc',
  },
  featureIcon: {
    width: '28px',
    height: '28px',
    borderRadius: '8px',
    background: 'rgba(255, 238, 88, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#ffee58',
    fontSize: '16px',
  },
  verifyContainer: {
    width: '100vw',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',
  },
  verifyCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '440px',
    background: '#2C325C',
    borderRadius: '16px',
    padding: '48px 36px',
    boxShadow: '0 16px 48px rgba(0, 0, 0, 0.3)',
  },
});

// Keep old exports for backward compatibility
export const BackgroundWave = styled('img')({ display: 'none' });
export const LeftImg = styled(Box)({ display: 'none' });
export const FormContainer = styled(Box)({ display: 'contents' });
export const Icon = styled(Box)({});
